import { useEffect, useState } from 'react';
import { useAppSelector } from '@/store/hooks';
import { selectGreenroomMeeting, selectGreenroomMeetingLoading } from '@/store/slices/project/selectors';
import GetGreenroomMeetingFeatureFlags from '@/connection/greenroom/get-greenroom-meeting-feature-flags';

type TUseSegmentsFeatureFlagResult = {
  segmentsEnabled: boolean;
  loading: boolean;
};

export default function useSegmentsFeatureFlag(): TUseSegmentsFeatureFlagResult {
  const greenroomMeeting = useAppSelector(selectGreenroomMeeting);
  const loadingGreenroomMeeting = useAppSelector(selectGreenroomMeetingLoading);
  const [segmentsEnabled, setSegmentsEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (loadingGreenroomMeeting) return;
    if (!greenroomMeeting) {
      setLoading(false);
      return;
    }

    setLoading(true);
    GetGreenroomMeetingFeatureFlags(greenroomMeeting.meeting)
      .then((flags) => setSegmentsEnabled(flags?.use_segments ?? false))
      .catch(() => setSegmentsEnabled(false))
      .finally(() => setLoading(false));
  }, [greenroomMeeting, loadingGreenroomMeeting]);

  return { segmentsEnabled, loading };
}
